/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Price_SaleInputs */

const cs_col_price_sale = /** @type {(inputs: Col_Price_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejní cena`)
};

const en_col_price_sale = /** @type {(inputs: Col_Price_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale Price`)
};

/**
* | output |
* | --- |
* | "Sale Price" |
*
* @param {Col_Price_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_price_sale = /** @type {((inputs?: Col_Price_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Price_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_price_sale(inputs)
	return cs_col_price_sale(inputs)
});